export const ProductionSimulationPositionMachine = (
	json: IProductionSimulationPositionMachine,
): IProductionSimulationPositionMachineModel => {
	const { machine_type_uuid, short_name, ...rest } = json

	return {
		...rest,
		machineTypeUUID: machine_type_uuid,
		shortName: short_name,
	}
}

export const ProductionSimulationPositionObj = (
	json: IProductionSimulationPositionObj,
): IProductionSimulationPositionObjModel => {
	const { production_simulation_stage_id, workers_count, production_machine_id, production_machine, ...rest } = json

	return {
		...rest,
		productionSimulationStageID: production_simulation_stage_id,
		workersCount: workers_count,
		productionMachineID: production_machine_id,
		productionMachine: production_machine ? ProductionSimulationPositionMachine(production_machine) : null,
	}
}

export const ProductionSimulationPositionStage = (
	json: IProductionSimulationPositionStage,
): IProductionSimulationPositionStageModel => {
	const { production_simulation_socket_id, production_stage_id, positions, ...rest } = json

	return {
		...rest,
		productionSimulationSocketID: production_simulation_socket_id,
		productionStageID: production_stage_id,
		positions: positions.map(ProductionSimulationPositionObj),
	}
}

export const ProductionSimulationPosition = (
	json: IProductionSimulationPosition,
): IProductionSimulationPositionModel => {
	const { is_added, production_simulation_id, production_socket_id, stages, ...rest } = json

	return {
		...rest,
		isAdded: is_added,
		productionSimulationID: production_simulation_id,
		productionSocketID: production_socket_id,
		stages: stages.map(ProductionSimulationPositionStage),
	}
}
